import styled from 'styled-components';

export const Logo = styled.span`
  font-family: '3M Trislan', sans-serif;
  font-size: 35px;
  color: var(--secondary-color);
  font-weight: 600;
  user-select: 'none';
  cursor: pointer;
`;
